module.exports = __webpack_public_path__ + "static/media/laptop.1f189ef7.png";